import { FC, Fragment } from 'react';
import { Check, X } from 'react-feather';
import Toggle from './CustomToggle';
import { Label } from '../../typography';

type CheckedProps = {
  checked: boolean;
  falseText?: string;
  id: string;
  label?: string;
  trueText?: string;
  onChange?: (option: any) => void;
};

const Checked: FC<CheckedProps> = ({ checked, falseText, id, label, trueText, onChange }) => {
  return (
    <Fragment>
      {label && <Label htmlFor={id}>{label}</Label>}
      <Toggle isChecked={checked} onClick={onChange} id={id}>
        <div className="check">{checked ? <Check /> : <X />}</div>
        <span>{checked ? trueText : falseText}</span>
      </Toggle>
    </Fragment>
  );
};

Checked.defaultProps = {
  falseText: 'No',
  trueText: 'Yes',
};

export default Checked;
